module.exports = __webpack_public_path__ + "static/media/blue-november.27a9ee5f.jpg";